"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFlowContainerDataHandlers = exports.useItemHandlers = void 0;

var uuid_1 = require("uuid");

var core_1 = require("@bodiless/core");

function useItemHandlers() {
  var node = core_1.useNode().node;

  var getItems = function getItems() {
    var items = node.data.items;
    return items || [];
  };

  var setItems = function setItems(items) {
    node.setData({
      items: items
    });
  };

  var deleteItem = function deleteItem(uuid) {
    var path$ = uuid ? node.path.concat(uuid) : node.path;
    node.delete(path$);
  };

  return {
    getItems: getItems,
    setItems: setItems,
    deleteItem: deleteItem
  };
}

exports.useItemHandlers = useItemHandlers;

function useFlowContainerDataHandlers() {
  var _a = useItemHandlers(),
      getItems = _a.getItems,
      setItems = _a.setItems,
      deleteItem = _a.deleteItem;

  var findItem = function findItem(startItem) {
    var items = getItems();
    if (!startItem) return items.length;
    var index = items.findIndex(function (item) {
      return startItem.uuid === item.uuid;
    });
    return index === -1 ? items.length : index;
  };

  var spliceItem = function spliceItem(start, deleteCount, newItem) {
    var newItems = __spreadArrays(getItems());

    if (newItem) newItems.splice(start, deleteCount, newItem);else newItems.splice(start, deleteCount);
    setItems(newItems);
  };

  return {
    insertFlowContainerItem: function insertFlowContainerItem(componentName, afterItem, wrapperPropsToClone) {
      if (wrapperPropsToClone === void 0) {
        wrapperPropsToClone = {};
      }

      var newItem = {
        uuid: uuid_1.v1(),
        wrapperProps: wrapperPropsToClone,
        type: componentName
      };
      var index = findItem(afterItem);
      spliceItem(index + 1, 0, newItem);
      return newItem;
    },
    setFlowContainerItems: setItems,
    updateFlowContainerItem: function updateFlowContainerItem(flowContainerItem) {
      var index = findItem(flowContainerItem);

      if (index < getItems().length) {
        spliceItem(index, 1, flowContainerItem);
      }
    },
    onFlowContainerItemResize: function onFlowContainerItemResize(uuid, itemProps) {
      var items = getItems();
      var itemIndex = findItem({
        uuid: uuid
      });

      if (itemIndex < items.length) {
        var currentFlowContainerItem = items[itemIndex];

        var updatedFlowContainerItem = __assign(__assign({}, currentFlowContainerItem), {
          wrapperProps: __assign(__assign({}, currentFlowContainerItem.wrapperProps || {}), itemProps)
        });

        if (JSON.stringify(currentFlowContainerItem) !== JSON.stringify(updatedFlowContainerItem)) {
          spliceItem(itemIndex, 1, updatedFlowContainerItem);
        }
      }
    },
    deleteFlowContainerItem: function deleteFlowContainerItem(uuid) {
      var index = findItem({
        uuid: uuid
      });
      if (index >= getItems().length) return undefined;
      spliceItem(index, 1);
      var items = getItems();
      deleteItem(uuid);
      return items[index] || items[items.length - 1];
    }
  };
}

exports.useFlowContainerDataHandlers = useFlowContainerDataHandlers;